import React, { Component } from 'react'
import { inject, observer, PropTypes } from 'mobx-react'
import { parse } from 'query-string'
import Page from './Page'
import ResetPasswordForm from '../components/ResetPasswordForm'

@inject('user')
@observer
class ResetPasswordPage extends Component {
  render () {
    const { token } = parse(this.props.location.search.substr(1)) // parse(window.location.search.substr(1))
    console.log('ResetPasswordPage.js - token:', token)

    return (
      <Page title='Reset password'>
        <article className='b-info'>
          <h2 className='b-info-title'>Reset password</h2>
          <ResetPasswordForm reset_token={token} />
        </article>
      </Page>
    )
  }
}

ResetPasswordPage.propTypes = {
  location: PropTypes.objectOrObservableObject,
  user: PropTypes.observableObject
}

export default ResetPasswordPage



// WEBPACK FOOTER //
// ./src/containers/ResetPasswordPage.js